import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { logUI } from '../../api/andyliticsApi';
import * as Tools from "../../helpers/Tools";

const PreventiveCareExamTile = props => {
    try {
        const { hasMyChart, serverData } = props;
        
        const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling ? serverData.enableCustomDirectScheduling : false;
        return <div className="card preventiveCare-tile">
            <div className="card-header">
                <div className="row">
                    <div className="col-12">
                        <div className="card-heading d-flex">
                            <span className="svg-schedule-color"></span>
                            <div className="preventiveCare-heading">PREVENTIVE CARE EXAM</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body mt-2">
                <div className="row">
                    <div className="col-12">
                        <p>If you haven't already, be sure to schedule your annual wellness-visit with your doctor.</p>
                    </div>
                </div>
            </div>
            <div className="card-footer">
                <div className="row">
                    <div className="col-12 text-right">
                        {!hasMyChart ?
                            <a className="card-link" href="http://www.bswhealth.com/" target="_blank">SCHEDULE APPOINTMENT</a> :
                            <Link className="card-link" to={{
                                pathname: enableCustomDirectScheduling ? "/schedule/DirectSchedule" : "/findcare",
                                state: { fromPreventiveCareTile: true }
                            }} onClick={() => logUI("MBHWeb.UI.WellBeingDashboard.PreventiveCareExamTile.Schedule", new Date(), Tools.getURLPath())}>SCHEDULE APPOINTMENT</Link>
                        }
                    </div>
                </div>
            </div>
        </div>;
    } catch (ex) {
        console.error(ex);
    }
}


const mapStateToProps = (state) => {
    return {
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        serverData: state.session.serverData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreventiveCareExamTile));